/**
 * Filter for translation strings
 */
(function() {

    'use strict';

    angular
    .module('itxApp.common')
    .filter('mspotText', ItxTranslateFlt);

    ItxTranslateFlt.$inject = [
        'itxmSpotUtilsSvc'
    ];

    function ItxTranslateFlt(
        itxmSpotUtilsSvc
    ) {
        var cache = {};

        function flt(value) {
            if (cache[value]) {
                return cache[value].value;
            }
            if (!cache[value]) {
                cache[value] = { isWaiting: false };
            }
            if (cache[value].isWaiting === false) {
                itxmSpotUtilsSvc.getString(value).then(function(res) {
                    cache[value].isWaiting = true;
                    cache[value].value = res;
                });
            }
        }
        flt.$stateful = true;
        return flt;
    }

})();